// Here are the values of keys healed by the localization module when done
// Edit the localize pipe to get the value from the module when done with it
// Edit this key to match the key in localization module

// button prefix
// 'aumico_button_'
// service prefix
// 'aumico_users'

export const defaultLocalizationValues = {
    // general
    aumico_users_aumico_form_error: 'Aumico form error',

    // // validations
    // aumico_users_form_validation_enter_company_name_required: 'Please enter organization name',

    // // labels and titles
    aumico_users_edit_user_company_general_information_edit_your_profile: 'Edit your Profile',
    aumico_users_edit_user_company_general_information_name: 'Name',
    aumico_users_edit_user_company_general_information_street: 'Street',
    aumico_users_edit_user_company_general_information_no: 'No.',
    aumico_users_edit_user_company_general_information_address_addition: 'Address Addition',
    aumico_users_edit_user_company_general_information_zip: 'Zip',
    aumico_users_edit_user_company_general_information_city: 'City',
    aumico_users_edit_user_company_general_information_country: 'Country',
    aumico_users_edit_user_company_general_information_company_logo: 'Organization Logo',
    aumico_users_edit_user_company_general_information_upload_logo_label: 'Upload Organization Logo',
    aumico_users_edit_user_company_general_information_upload_logo_text:
        'Drag & Drop a pdf with the organization logo here',
    aumico_users_edit_user_company_general_information_upload_logo_extension_error:
        'Please upload a file of pdf extension',
    aumico_users_edit_user_general_information_edit_your_profile: 'Edit your Profile',
    aumico_users_edit_user_general_information_salutation: 'Salutation',
    aumico_users_edit_user_general_information_name: 'Name',
    aumico_users_edit_user_general_information_surname: 'Surname',
    aumico_users_edit_user_general_information_email_address: 'E-Mail Address',
    aumico_users_edit_user_general_information_phone: 'Phone',
    aumico_users_edit_user_general_information_settings: 'Settings',
    aumico_users_edit_user_general_information_langugage: 'Language',
    aumico_users_edit_user_general_information_languages_english: 'English',
    aumico_users_edit_user_general_information_languages_german: 'German',
    aumico_users_edit_user_general_information_salutations_mr: 'Mr',
    aumico_users_edit_user_general_information_salutations_mrs: 'Mrs',
    aumico_users_edit_user_security_authentication: 'Authentication',
    aumico_users_edit_user_security_enable_two_factor_authentication: 'Enable 2-Factor Authentication',
    aumico_users_edit_user_security_change_password: 'Change Password',
    aumico_users_edit_user_security_current_password: 'Current Password',
    aumico_users_edit_user_security_new_password: 'New Passowrd',
    aumico_users_edit_user_security_repeat_new_password: 'Repeat new Password',
    aumico_admin_user_list_notification_success_title: 'Success!',
    aumico_admin_user_list_notification_success_description: 'User Updated Successfully',
    aumico_admin_user_organization_notification_success_description: 'Organization Updated Successfully',
    aumico_admin_user_list_notification_failure_description: 'Error Occurred please try again later or contact us',
    aumico_admin_user_list_notification_failure_title: 'Failure!',
    // // placeholders
    aumico_users_edit_user_company_general_information_enter_name: 'Enter Name',
    aumico_users_edit_user_company_general_information_enter_street: 'Enter Street',
    aumico_users_edit_user_company_general_information_enter_no: 'Enter No.',
    aumico_users_edit_user_company_general_information_enter_zip: 'Enter Zip',
    aumico_users_edit_user_company_general_information_enter_city: 'Enter City',
    aumico_users_edit_user_company_general_information_choose_country: 'Choose Country',
    aumico_users_edit_user_general_information_select_salutation: 'Select the Salutation',
    aumico_users_edit_user_general_information_enter_name: 'Enter the Name',
    aumico_users_edit_user_general_information_enter_surnmae: 'Enter the Surname',
    aumico_users_edit_user_general_information_enter_email_address: ' Enter the E-Mail address',
    aumico_users_edit_user_general_information_enter_phone_number: 'Enter the phone number',
    aumico_users_edit_user_general_information_choose_language: 'Choose the language',
    aumico_users_edit_user_security_enter_current_password: 'Enter current password',
    aumico_users_edit_user_security_enter_new_password: 'Enter new password',
    aumico_users_edit_user_security_confirm_new_password: 'Confirm new password',
    aumico_users_company_profile_general_information_side_margins:
        'Side margins: top: 5cm, bottom: 2cm, left: 1.5cm, right: 1.5cm',

    // personal information
    aumico_users_personal_information_main_title: 'We would like to get to know you',
    aumico_users_personal_information_sub_title: 'Please provide us with the following information:',
    aumico_users_personal_information_organization_label: 'Your organization',
    aumico_users_personal_information_language_section_title: 'Choose your language',
    aumico_reports_input_please_enter_placeholder: 'Please enter',
    aumico_reports_registration_welcome_first_name_label: 'First name',
    aumico_reports_registration_welcome_first_name_error: 'First name is required',
    aumico_reports_registration_welcome_last_name_label: 'Last name',
    aumico_reports_registration_welcome_last_name_error: 'Last name is required',
    aumico_users_personal_information_organization_error: 'Organization is required',
    aumico_users_personal_information_language_error: 'Language is required',

    // organization users
    aumico_users_organization_users_table_name_label: 'User',
    aumico_users_organization_users_table_email_label: 'E-mail',
    aumico_users_organization_users_table_phone_number_label: 'Phone Number',
    aumico_users_organization_users_table_date_added_label: 'Date Added',
    aumico_users_organization_users_table_status_label: 'Status',
    aumico_users_organization_users_table_pending_label: 'Pending',
    aumico_users_organization_users_table_active_label: 'Active',

    aumico_users_organization_users_table_remove_users: 'Remove from organization',
    aumico_users_organization_users_remove_confirmation_text:
        'The selected users will lose their access to the platform. Are you sure you want to remove them?',
    aumico_users_organization_users_remove_confirmation_button: 'Remove',
    aumico_users_organization_users_remove_cancel_button: 'Cancel',
    aumico_users_organization_change_organization_state_action: 'Change State',
    aumico_users_organization_change_organization_state_modal_title: 'Change Organization State',
    aumico_users_organization_change_organization_state_modal_confirm_action: 'Confirm',
    // registration
    aumico_users_registration_main_title: 'Set your credentials and get started',
    aumico_users_registration_sub_title: 'Set a password & start collaborating with your colleagues.',
    aumico_reports_reset_password_forgot_email_username: 'E-Mail / Username',
    aumico_users_registration_email_username_placeholder: 'Pleas enter E-Mail address',
    aumico_users_registration_email_username_required_error: 'E-Mail / Username is required',
    aumico_reports_reset_password_credentials_error: 'Username or email is wrong!',
    aumico_reports_registration_welcome_privacy_policy_error: 'Privacy policy is required',
    aumico_users_registration_read_and_agree: 'I have read and agree to the website',
    aumico_reports_accept_policy_dialog_first_paragraph_the: 'the',
    aumico_reports_accept_policy_dialog_first_paragraph_as_well_as_those: 'as well as the',
    aumico_users_registration_text_between_links:
        'of aumico and I agree with them. Furthermore, I have taken note of aumico',
    aumico_users_registration_text_after_links: '',
    aumico_users_registration_privacy_policy: 'Data Protection Regulation.',
    aumico_users_registration_prices: 'Prices',
    aumico_users_registration_terms_and_conditions: 'General Terms and conditions',
    aumico_users_registration_agreement_on_data_processing: 'Data Processing Agreement',
    aumico_reports_registration_welcome_market_communication_subscription:
        'Yes, I would like to receive marketing communications about aumico products, services, and events. I can cancel this subscription at any time.',

    // password
    aumico_users_registration_password_label: 'Set password',
    aumico_reports_registration_welcome_repeat_password_label: 'Repeat password',
    aumico_reports_registration_welcome_password_error: 'Password is required',
    aumico_reports_registration_welcome_repeat_password_error: 'Repeat password is required',
    aumico_reports_registration_welcome_password_match_error: 'Passwords Must Match',
    aumico_reports_registration_welcome_password_validation_error: "Password doesn't meet the rules.",
    aumico_users_registration_password_placeholder: 'Please enter password',

    // reset-password
    aumico_users_reset_password_button: 'Reset Password',
    aumico_googleidp_invalid_code_error_message_title: 'Expired or Invalid Code',
    aumico_googleidp_invalid_code_error_message_content: 'Your Verification Mail is Expired or invalid',
    aumico_reports_registration_confirmation_bottom_question_button: 'Resend Email',
    //sign-up
    aumico_users_signup_continue_button: 'Continue',
    aumico_reports_registration_create_account_button: 'Create Account',
    aumico_users_signup_creating_your_account_button: 'Creating your account',

    aumico_change_password_notification_success: 'Password changed Successfully',
    aumico_change_password_notification_failed: 'Error occurred while changing password',
    aumico_change_password_notification_success_title: 'Success!',
    aumico_change_password_notification_failed_title: 'Failed!',
    aumico_change_password_relogin_title: 'Password changed',
    aumico_change_password_relogin_description: 'Your password has been changed. Please log in again.',
    aumico_change_password_relogin_failed_title: 'Log in again',
    aumico_change_password_relogin_failed_description: 'Your password was not changed. Please log in again.',
    aumico_change_password_relogin_button: 'Log out',
    // Errors
    aumico_errors_server_error: 'Server Error',
    aumico_user_email_already_exists_error: 'This email already exists',
    aumico_empty_field_error: 'Empty value is not allowed',
    aumico_users_organization_upload_pdf_template_action: 'Upload Pdf Template',
    aumico_users_organization_reset_to_default_template_action: 'Reset to default template',
    aumico_users_organization_upload_pdf_template_failure_notification_description:
        'Failed to upload reporting template',
    aumico_users_organization_upload_pdf_template_success_notification_description:
        'Reporting template uploaded successfully',
    aumico_users_organization_reset_to_default_template_action_success: 'Reset to default template succeeded',
    aumico_users_organization_reset_to_default_template_action_failed: 'Reset to default template failed',
    aumico_users_organization_upload_or_pdf_template_action: 'Upload OR Pdf template',
    aumico_users_organization_upload_hgb_pdf_template_action: 'Upload HGB Pdf template',
    aumico_users_organization_reset_to_default_or_template_action: 'Reset OR template to default',
    aumico_users_organization_reset_to_default_hgb_template_action: 'Reset HGB template to default',
} as const;

type PickTypeOfKey<T> = {
    [P in keyof T]: P;
};

// just getting the value of the key
export const localizationKeys = Object.keys(defaultLocalizationValues).reduce((acc, key) => {
    acc[key] = key;
    return acc;
}, {} as PickTypeOfKey<typeof defaultLocalizationValues>);
